if (!customElements.get("announcement-bar")) {
  customElements.define(
    "announcement-bar",
    class AnnouncementBar extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          carousel: ".mobile-announcement-bar__slider",
        };

        this.init();
      }

      init() {
        this.carousel = new Flickity(this.querySelector(this.selectors.carousel), {
          cellAlign: "center",
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false,
          autoPlay: 3000,
        });
      }
    }
  );
}
